import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import * as moment from "moment";
import { Anchor, Image } from "hesus-ui-kit";
import { getDateFormat } from "@utils/datePickerUtils";
import { useGetGeneralParameters } from "@hooks/useGeneralParams";
import AddEditClient from "../AddEditClient/AddEditClient";
import editIcon from "@icons/ic-edit-blue.svg";
import {
  HaulierInfo,
  FlexRow,
  GridRow,
  SubTitle,
  SubTitleBold,
  FinaceSection,
  FinaceSubTitle,
} from "./ClientView.styled";
import "../../CompanyView.scss";
import {
  renderPriceWithCurrencyWithoutUnit,
  addSpaceWithoutFloat,
} from "@utils/utils";

const ClientView = (props) => {
  const { t, data, updateRefeshStatus } = props;

  const currentMomentDate = moment(new Date()).format("YYYY-MM-DD");
  const newCurrentDate = new Date(currentMomentDate).getTime();
  const generalParams = useGetGeneralParameters();
  const [isClientPopUpOpen, setIsClientPopUpOpen] = useState(false);

  const { countryCurrencyPosition } = generalParams;
  const currencyList = generalParams.countryCurrency;

  const getCreditBoxColor = (date) => {
    let color = 2;
    if (date) {
      const expirationDate = new Date(date).getTime();
      if (expirationDate >= newCurrentDate) {
        color = 1;
      }
    }
    if (!date) {
      color = 1;
    }
    return color;
  };

  const getBudget = (creditLimit, hesusCover) => {
    let creditLimitAmount = 0;
    let hesusCoverAmount = 0;
    if (creditLimit.expirationDate) {
      const expirationDate = new Date(creditLimit.expirationDate).getTime();
      if (expirationDate >= newCurrentDate) {
        creditLimitAmount = creditLimit.amount;
      }
    }
    if (hesusCover.expirationDate) {
      const expirationDate = new Date(hesusCover.expirationDate).getTime();
      if (expirationDate >= newCurrentDate) {
        hesusCoverAmount = hesusCover.amount;
      }
    }
    if (!hesusCover.expirationDate) {
      hesusCoverAmount = hesusCover.amount;
    }
    return parseInt(creditLimitAmount, 10) + parseInt(hesusCoverAmount, 10);
  };

  const editClientInfo = () => {
    setIsClientPopUpOpen(true);
  };

  const onClientPopUpClose = () => {
    setIsClientPopUpOpen(false);
  };

  return (
    <HaulierInfo>
      {!!data?.id && Object.keys(generalParams).length > 0 && (
        <>
          <GridRow column="1fr auto">
            <div>
              <FlexRow>
                <SubTitleBold>
                  {t("COMPANY_INTRACOM_VAT_NUMBER")} :
                </SubTitleBold>
                <SubTitle>
                  {data.intracomVatNumber ? data.intracomVatNumber : "-"}
                </SubTitle>
              </FlexRow>
              <FlexRow>
                <SubTitleBold>
                  {t("COMPANY_CREDIT_LIMIT_HOLDER")} :
                </SubTitleBold>
                <SubTitle>
                  {!!data?.creditLimit?.hasCreditLimitHolder && (
                    <Anchor
                      url={`/company/view/${data?.creditLimit?.companyId}/general-info`}
                      target="_blank"
                      rel="noreferrer"
                      styles={{
                        textDecoration: "underline !important",
                      }}
                    >
                      {data?.creditLimit?.companyId +
                        " - " +
                        data?.creditLimit?.companyName}
                    </Anchor>
                  )}
                  {!data?.creditLimit?.hasCreditLimitHolder && data?.name}
                </SubTitle>
              </FlexRow>
              <FlexRow>
                <SubTitleBold>{t("COMPANY_FINANCIAL_COMMENT")} :</SubTitleBold>
                <SubTitle>
                  {data?.financialComment ? (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: data.financialComment,
                      }}
                    ></div>
                  ) : (
                    "-"
                  )}
                </SubTitle>
              </FlexRow>
            </div>

            <div>
              <FlexRow>
                <Image
                  src={editIcon}
                  onClick={editClientInfo}
                  title={t("COMPANY_CLIENT_ACTION_TOOLTIP_EDIT")}
                  alt={t("COMPANY_CLIENT_ACTION_TOOLTIP_EDIT")}
                  className="company-centre-view__image-icon-client_info"
                />
              </FlexRow>
            </div>
          </GridRow>
          <GridRow column="30% 30% 30% auto" gap="1rem">
            <FinaceSection color="#00aeea">
              <FinaceSubTitle color="#00aeea">
                {t("COMPANY_REMAINING_BUDGET_SECTION_LABEL")}
              </FinaceSubTitle>
              <FinaceSubTitle fontSize="18px" color="#0A4986">
                {renderPriceWithCurrencyWithoutUnit(
                  0,
                  currencyList[data.platformCountryId],
                  countryCurrencyPosition[data.platformCountryId]
                )}{" "}
                /
                {renderPriceWithCurrencyWithoutUnit(
                  addSpaceWithoutFloat(
                    getBudget(data?.creditLimit, data?.hesusCover)
                  ),
                  currencyList[data.platformCountryId],
                  countryCurrencyPosition[data.platformCountryId]
                )}
              </FinaceSubTitle>
              <FinaceSubTitle
                fontSize="12px"
                fontStyle="italic"
                fontWeight="400"
                color={
                  getCreditBoxColor(data?.creditLimit?.expirationDate) === 1
                    ? "#474747"
                    : "#cccc"
                }
              >
                {" "}
              </FinaceSubTitle>
            </FinaceSection>
            <FinaceSection
              color={
                getCreditBoxColor(data?.creditLimit?.expirationDate) === 1
                  ? "#00aeea"
                  : "#cccc"
              }
            >
              <FinaceSubTitle
                color={
                  getCreditBoxColor(data?.creditLimit?.expirationDate) === 1
                    ? "#00aeea"
                    : "#cccc"
                }
              >
                {t("COMPANY_CREDIT_LIMIT_SECTION_LABEL")}
              </FinaceSubTitle>
              <FinaceSubTitle
                fontSize="18px"
                color={
                  getCreditBoxColor(data?.creditLimit?.expirationDate) === 1
                    ? "#0A4986"
                    : "#cccc"
                }
              >
                {data?.creditLimit?.amount
                  ? renderPriceWithCurrencyWithoutUnit(
                      addSpaceWithoutFloat(data?.creditLimit?.amount),
                      currencyList[data.platformCountryId],
                      countryCurrencyPosition[data.platformCountryId]
                    )
                  : "-"}
              </FinaceSubTitle>
              <FinaceSubTitle
                fontSize="12px"
                fontStyle="italic"
                fontWeight="400"
                color={
                  getCreditBoxColor(data?.creditLimit?.expirationDate) === 1
                    ? "#474747"
                    : "#cccc"
                }
              >
                {t("COMPANY_CREDIT_LIMIT_SECTION_EXPIRATION")}:{" "}
                {data?.creditLimit?.expirationDate
                  ? getDateFormat(data?.creditLimit?.expirationDate, "YYYY-MM-DD")
                  : "-"}
              </FinaceSubTitle>
            </FinaceSection>
            <FinaceSection
              color={
                getCreditBoxColor(data?.hesusCover?.expirationDate) === 1
                  ? "#00aeea"
                  : "#cccc"
              }
            >
              <FinaceSubTitle
                color={
                  getCreditBoxColor(data?.hesusCover?.expirationDate) === 1
                    ? "#00aeea"
                    : "#cccc"
                }
              >
                {t("COMPANY_HESUS_COVER_SECTION_LABEL")}
              </FinaceSubTitle>
              <FinaceSubTitle
                fontSize="18px"
                color={
                  getCreditBoxColor(data?.hesusCover?.expirationDate) === 1
                    ? "#0A4986"
                    : "#cccc"
                }
              >
                {data?.hesusCover?.amount
                  ? renderPriceWithCurrencyWithoutUnit(
                      addSpaceWithoutFloat(data?.hesusCover?.amount),
                      currencyList[data.platformCountryId],
                      countryCurrencyPosition[data.platformCountryId]
                    )
                  : renderPriceWithCurrencyWithoutUnit(
                      0,
                      currencyList[data.platformCountryId],
                      countryCurrencyPosition[data.platformCountryId]
                    )}
              </FinaceSubTitle>
              <FinaceSubTitle
                fontSize="12px"
                fontStyle="italic"
                fontWeight="400"
                color={
                  getCreditBoxColor(data?.hesusCover?.expirationDate) === 1
                    ? "#474747"
                    : "#cccc"
                }
              >
                {t("COMPANY_HESUS_COVER_SECTION_EXPIRATION")}:{" "}
                {data?.hesusCover?.expirationDate
                  ? getDateFormat(data?.hesusCover?.expirationDate, "YYYY-MM-DD")
                  : "-"}
              </FinaceSubTitle>
            </FinaceSection>
          </GridRow>
          {isClientPopUpOpen && (
            <AddEditClient
              onClose={onClientPopUpClose}
              company={data}
              updateRefeshStatus={updateRefeshStatus}
            />
          )}
        </>
      )}
    </HaulierInfo>
  );
};

ClientView.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(ClientView);
